<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 18.5V5.5H17.75V18.5H14ZM6.25 18.5V5.5H10V18.5H6.25Z" fill="currentColor"/>
</svg>
